import CreditScore from '@mui/icons-material/CreditScore';
import LocalOffer from '@mui/icons-material/LocalOffer';
import { Stack, type SxProps, type Theme, Typography } from '@mui/material';
import GetPromoImageBase64 from './BenefitsBannerPromoImage';
import { styled } from '@mui/material';

const Container = styled('div')(({ theme }) => ({
  border: '1px solid #E0E0E0',
  padding: `${theme.spacing(3)}`,
  display: 'flex',
  flexDirection: 'column',
  gap: `${theme.spacing(1)}`,
  borderRadius: '10px',
}));

export type BenefitsBannerProps = {
  bannerState: 'Commissioned' | 'Commissionable' | 'Promo';
  title?: string;
  body?: string;
};

/**
 * BenefitsBanner component from [MicroLibraryAppDetailsUI](https://dev.azure.com/orcha/MicroLibraryTemplate/_git/MicroLibraryAppDetailsUI)
 * @param {BenefitsBannerProps} benefitsBannerProps - The props for the BenefitsBanner component
 * @returns {ReactElement} The BenefitsBanner component
 */
export const BenefitsBanner = ({
  bannerState,
  title,
  body,
}: BenefitsBannerProps) => {
  let containerStyles: SxProps<Theme> | undefined;
  let icon;
  switch (bannerState) {
    case 'Commissionable':
      containerStyles = { backgroundColor: '#FDE9F2' };
      icon = <CreditScore sx={{ color: '#E31C79' }} />;
      break;
    case 'Commissioned':
      containerStyles = { backgroundColor: '#ECFAFB' };
      icon = <CreditScore sx={{ color: '#009FCE' }} />;
      break;
    case 'Promo':
      containerStyles = {
        backgroundImage: `url(data:image/jpeg;base64,${GetPromoImageBase64()})`,
        backgroundSize: 'cover',
        color: 'white',
      };
      icon = (
        <LocalOffer
          sx={{
            color: '#62DA67',
          }}
        />
      );
      break;
    default:
      return <></>;
  }

  return (
    <Container sx={containerStyles} data-testid="app-benefits-banner">
      <Stack direction="row" alignItems="center" gap={1}>
        {icon}
        <Typography sx={{ fontSize: '1.125rem', fontWeight: 'bold' }}>
          {title}
        </Typography>
      </Stack>

      <Typography variant="body1" sx={{ fontWeight: 500 }}>
        {body}
      </Typography>
    </Container>
  );
};
